module.exports = __webpack_public_path__ + "img/1438035608.d14135b2.jpg";